var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconAdmin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 10 12.12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.49 8.39 2.06 7a.55.55 0 0 1 .78-.78l1.05 1L7.16 4a.55.55 0 1 1 .78.78L4.28 8.39a.56.56 0 0 1-.79 0M4.55.1.66 1.82a1.12 1.12 0 0 0-.66 1v2.63a6.92 6.92 0 0 0 5 6.67 6.92 6.92 0 0 0 5-6.67V2.84a1.12 1.12 0 0 0-.66-1L5.45.1a1.1 1.1 0 0 0-.9 0",
  className: "icon-admin_svg__cls-1"
})));
export default SvgIconAdmin;